import React, { useContext } from "react";
import Select from "react-select";
import { ProductsContext } from "../context/products.context";

const OptionsSchoolCipEquity = (props) => {
  const { selectedSchool, setSelectedSchool, listSchools, cipEquityData } = useContext(ProductsContext);
  const { isMulti } = props;

  // Check if cipEquityData is defined and has at least one element with enrollment data
  if (!cipEquityData || cipEquityData.length === 0 || !cipEquityData[0]?.enrollment) {
    // Return null or a message if you want to handle "no enrollment data" scenario
    return (
      <div className="text-sm text-gray-500">
        No enrollment data available for this CIP.
      </div>
    );
  }

  const availableSchools = cipEquityData[0].enrollment.map((f) => f.schoolName);

  const optionsSchools = [
    { value: "District Total", label: "District Total" },
    ...listSchools
      .filter((f) => availableSchools.includes(f))
      .map((e) => ({ value: e, label: e })),
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#ffffff",
      cursor: "pointer",
      "&:hover": {
        borderColor: "#818cf8",
      },
      minHeight: "40px",
      height: "40px",
      outline: "none",
      boxShadow: state.isFocused ? null : null,
    }),

    input: (provided) => ({
      ...provided,
      marginLeft: "2px",
    }),
  };

  return (
    <div>
      <div className="inline-block">
        <span className="text-sm font-medium">Select School:</span>
        <Select
          className="ml-2 min-w-[245px]"
          {...props}
          controlShouldRenderValue={!isMulti}
          maxMenuHeight={800}
          components={{
            DropdownIndicator: () => (
              <div className="pr-2 text-gray-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                  />
                </svg>
              </div>
            ),
            IndicatorSeparator: () => null,
          }}
          onChange={setSelectedSchool}
          options={optionsSchools}
          value={selectedSchool}
          styles={customStyles}
          isClearable={false}
        />
      </div>
    </div>
  );
};

export default OptionsSchoolCipEquity;